import { StaticImage } from 'gatsby-plugin-image';

import {
  EMERGENCY_SPOT_PATCHES_ECOMMERCE_PRICE,
  THE_CLEANSER_ECOMMERCE_PRICE,
  THE_MOISTURIZER_ECOMMERCE_PRICE,
} from 'consts/copy';
import ECOMMERCE_URLS from 'consts/eCommerceUrls';
import { PRODUCT_LINKS } from 'consts/products';

import type { SubsectionProps } from '../components';

export const ECOM_PRODUCTS_MODULE: SubsectionProps = {
  moduleName: 'eCommerceProducts',
  title: 'Routine add-ons',
  subtitle: 'Build your box with our line of trusted essentials.',
  ctaButtonText: 'Explore all products',
  ctaECommerceLink: ECOMMERCE_URLS.main,
  accentImage: {
    image: {
      desktop: (
        <StaticImage
          src="../images/woman-with-cleanser-desktop@2x.jpg"
          alt="A smiling woman holding a bottle of Curology cleanser next to her face."
          layout="fixed"
          width={331}
        />
      ),
      mobile: (
        <StaticImage
          src="../images/woman-with-cleanser-mobile@2x.jpg"
          alt="A smiling woman holding a bottle of Curology cleanser next to her face."
          layout="fullWidth"
        />
      ),
    },
  },
  productCards: [
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.cleanser,
      name: 'The Cleanser',
      description: 'Lightly foaming face wash',
      price: THE_CLEANSER_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/cleanser@2x.jpg"
          alt="A bottle of Curology's cleanser."
          objectFit="contain"
        />
      ),
    },
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.moisturizer,
      name: 'Gel Moisturizer',
      description: 'Lightweight daily hydration',
      price: THE_MOISTURIZER_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/moisturizer@2x.jpg"
          alt="A bottle of Curology's moisturizer."
          objectFit="contain"
        />
      ),
    },
    {
      linkType: PRODUCT_LINKS.eCommerce,
      href: ECOMMERCE_URLS.emergencySpotPatch,
      name: 'Emergency Spot Patch',
      description: 'Fast-acting healing support',
      price: EMERGENCY_SPOT_PATCHES_ECOMMERCE_PRICE,
      image: (
        <StaticImage
          src="../images/emergency-spot-patches@2x.jpg"
          alt="A package of Curology's emergnency spot patches."
          objectFit="contain"
        />
      ),
    },
  ],
};

export const ECOM_PRODUCTS_MODULE_ADDONS_EXPERIMENT_VARIANT_BASE: SubsectionProps =
  {
    ...ECOM_PRODUCTS_MODULE,
    title: 'Shop routine essentials',
    subtitle:
      'Easy-to-use skincare essentials designed by dermatologists and made for all skin types',
    ctaButtonText: 'Go to The Curology Shop',
    accentImage: undefined,
  };
